import React, { useState, useEffect, useCallback } from "react";
import './../../App.css';
import './Transactions.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import {CreateTableForEmployeeSelect} from '../ManageTable';
import axios from 'axios';
import {token, domain} from './../Security';
import loadingSpinner from './../../assets/loading.gif';
import {useTable, useSortBy} from 'react-table';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {globalTimeFormat} from './../Security';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
// icon
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SaveIcon from '@mui/icons-material/Save';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import ListIcon from '@mui/icons-material/List';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

function DTRAdminView({user, isHideSideMenu}) {
    var uploadTimeEntriesHeader_merged = [
        "Employee Id",
        "Employee",
        "Date",
        "Time In",
        "Device",
        "Time Out Break",
        "Device",
        "Time In Break",
        "Device",
        "Time Out",
        "Device",
        "Shift Name",
        "OT",
        "DTR Adjustment",
        "Leave",
        "Change Schedule",
        "Offset",
        "Official Business",
        "Other Logs",
    ]
    var uploadTimeEntriesaccessor_merged = [
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "date",
        "timeIn",
        "deviceNameTimeIn",
        "timeOutBreak",
        "deviceNameTimeOutBreak",
        "timeInBreak",
        "deviceNameTimeInBreak",
        "timeOut",
        "deviceNameTimeOut",
        "employeePersonalInformationEmployeeInformationShiftScheduleShiftName",
        "ot",
        "dtrCorrection",
        "leave",
        "changeSchedule",
        "offsetRequest",
        "officialBusiness",
        "otherLogs",
    ]
    var uploadTimeEntriesHeader = [
        "Employee Id",
        "Employee",
        "Date",
        "Time In",
        "Device",
        "Time Out Break",
        "Device",
        "Time In Break",
        "Device",
        "Time Out",
        "Device",
        "Shift Name"
    ]
    var uploadTimeEntriesaccessor = [
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "date",
        "timeIn",
        "deviceNameTimeIn",
        "timeOutBreak",
        "deviceNameTimeOutBreak",
        "timeInBreak",
        "deviceNameTimeInBreak",
        "timeOut",
        "deviceNameTimeOut",
        "employeePersonalInformationEmployeeInformationShiftScheduleShiftName",
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [mergedLogsData, setMergedLogsData] = useState([]); 
    const [originalMergedLogsData, setOriginalMergedLogsData] = useState([]); 
    const [biometricsData, setBiometricsData] = useState([]); 
    const [originalBiometricsData, setOriginalBiometricsData] = useState([]); 
    const [mobileDTRData, setMobileDTRData] = useState([]);
    const [originalMobileDTRData, setOriginalMobileDTRData] = useState([]);
    const [filterDataMergedLogs, setFilterDataMergedLogs] = useState([]);
    const [filterDataBiometrics, setFilterDataBiometrics] = useState([]);
    const [filterDataMobile, setFilterDataMobile] = useState([]);
    const [loadingRequest, setLoadingRequest] = useState(false);

    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [classificationId, setClassificationId] = useState(0);
    const [locationId, setLocationId] = useState(0);

    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const handleFilterMergedLogs = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = filterDataMergedLogs.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );

        setMergedLogsData(res);
    };
    const handleFilterBiometrics = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = filterDataBiometrics.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );

        setBiometricsData(res);
    };
    const handleFilterMobile = (value) => {
        setCurrentPage(1);

        const lowercaseValue = value.toLowerCase();
        var res = filterDataMobile.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );

        setMobileDTRData(res);
    };

    const handleSubmitMergedLogs = async (event) => {
        event.preventDefault();

        // const apiUrlFetch = domain + "/api/EmployeeTimeRecord/user-time-log-merged/data-only";
        const apiUrlFetch = domain + `/api/EmployeeTimeRecord/select-logs/data-only/new`;

        // setMergedLogsData([]);
        // setOriginalMergedLogsData([])
        // setFilterDataMergedLogs([])

        const data = {
            ...user,
            dateFrom: dateFrom,
            dateTo: dateTo,
            employeePersonalInformationId: employeePersonalInformationId ? employeePersonalInformationId : 0,
            locationId: locationId ?? 0,
            classificationId: classificationId ?? 0,
        };

        try {
            const response = await axios.post(apiUrlFetch, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            // const finalData = response.data.filter(record => record.timeIn || record.timeOut);
            const finalData = response.data;

            console.log("finalData", finalData)
            
            setMergedLogsData(finalData)
            setOriginalMergedLogsData(finalData)
            setFilterDataMergedLogs(finalData)
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }
    };
    const handleSubmitBiometrics = async (event) => {
        event.preventDefault();

        // const apiUrlFetch = domain + "/api/EmployeeTimeRecord/user-time-log-merged/data-only";
        const apiUrlFetch = domain + `/api/EmployeeTimeRecord/user-time-log-raw/data-only/new`;

        // setBiometricsData([]);
        // setOriginalBiometricsData([])
        // setFilterDataBiometrics([])

        const data = {
            ...user,
            dateFrom: dateFrom,
            dateTo: dateTo,
            employeePersonalInformationId: employeePersonalInformationId ? employeePersonalInformationId : 0,
            locationId: locationId ?? 0,
            classificationId: classificationId ?? 0,
        };

        try {
            const response = await axios.post(apiUrlFetch, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            // const finalData = response.data.filter(record => record.timeIn || record.timeOut);
            const finalData = response.data;
            
            setBiometricsData(finalData)
            setOriginalBiometricsData(finalData)
            setFilterDataBiometrics(finalData)
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage + " (Biometrics)");
        }
    };
    const handleSubmitMobile = async (event) => {
        event.preventDefault();

        const apiUrlFetch = domain + `/api/EmployeeTimeRecord/mobile-dtr/data-only/new`;

        // setMobileDTRData([]);
        // setOriginalMobileDTRData([])
        // setFilterDataMobile([])

        const data = {
            ...user,
            dateFrom: dateFrom,
            dateTo: dateTo,
            employeePersonalInformationId: employeePersonalInformationId ? employeePersonalInformationId : 0,
            locationId: locationId ?? 0,
            classificationId: classificationId ?? 0,
        };

        try {
            const response = await axios.post(apiUrlFetch, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            // const finalData = response.data.filter(record => record.timeIn || record.timeOut);
            const finalData = response.data;
            
            setMobileDTRData(finalData)
            setOriginalMobileDTRData(finalData)
            setFilterDataMobile(finalData)
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage  + " (Mobile)");
        }
    };
    const handleGenerate = async (e) => {
        if (!dateFrom || !dateTo) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please input Date From and Date To");
            return;
        }

        setCurrentPage(1)

        setLoadingRequest(true);
            
        // setIsGenerate(true);
        await handleSubmitMergedLogs(e);
        await handleSubmitBiometrics(e);
        await handleSubmitMobile(e);

        setLoadingRequest(false);
    };


    const [selectedTab, setSelectedTab] = useState(0);
    const handleSelectChange = (index) => {
        setSelectedTab(index);
        setFilterDataBiometrics(originalBiometricsData);
        setFilterDataMobile(originalMobileDTRData);
        setFilterDataMergedLogs(originalMergedLogsData);
    };

    const [showDTRCorrection, setShowDTRCorrection] = useState(false);
    const [showOT, setShowOT] = useState(false);
    const [showLeave, setShowLeave] = useState(false);
    const [showChangeSchedule, setShowChangeSchedule] = useState(false);
    const [showOtherLogs, setShowOtherLogs] = useState(false);
    const [showOffset, setShowOffset] = useState(false);
    const [showOfficialBusiness, setShowOfficialBusiness] = useState(false);
    const [requests, setRequests] = useState(null);
    const openDTRCorrection = (data) => {
        setShowDTRCorrection(true);
        setRequests(data.changeLogRequest)
    }
    const closeDTRCorrection = () => {
        setShowDTRCorrection(false);
        setRequests(null)
    }
    const openOT = (data) => {
        setShowOT(true);
        setRequests(data.otRequest)
    }
    const closeOT = () => {
        setShowOT(false);
        setRequests(null)
    }
    const openLeave = (data) => {
        setShowLeave(true);
        setRequests(data.leaveRequest)
    }
    const closeLeave = () => {
        setShowLeave(false);
        setRequests(null)
    }
    const openChangeSchedule = (data) => {
        setShowChangeSchedule(true);
        setRequests(data.changeScheduleRequest)
    }
    const closeChangeSchedule = () => {
        setShowChangeSchedule(false);
        setRequests(null)
    }
    const openOtherLogs = (data) => {
        setShowOtherLogs(true);
        setRequests(data.otherLogs)
    }
    const closeOtherLogs = () => {
        setShowOtherLogs(false);
        setRequests(null)
    }
    const openOffset = (data) => {
        setShowOffset(true);
        setRequests(data.offsetRequest);
    };
    const closeOffset = () => {
        setShowOffset(false);
        setRequests(null);
    };
    const openOfficialBusiness = (data) => {
        setShowOfficialBusiness(true);
        setRequests(data.officialBusiness);
    };
    const closeOfficialBusiness = () => {
        setShowOfficialBusiness(false);
        setRequests(null);
    };

    function formatDate(dateString) {
        if(!dateString){
            return '';
        }
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }
    
    function formatTime(time) {
        if(!time){
            return '';
        }

        const timePart = time.split('T')[1];
        if (timePart) {
            const [hour, minute] = timePart.split(':');
            const hours = parseInt(hour, 10);
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 || 12;

            return `${formattedHours}:${minute} ${ampm}`;
        }
    }

    const extractMergedLogs = async (type) => {
        setLoadingRequest(true)
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');
    
        const header = [
            'EMPLOYEE ID', 
            'EMPLOYEE NAME', 
            'DATE', 
            'TIME IN', 
            'DEVICE', 
            'TIME OUT', 
            'DEVICE', 
            `SHIFT NAME`,
        ];
        const headerRow = worksheet.addRow(header);
    
        worksheet.columns = [
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 25 },
            { key: 'date', width: 25 },
            { key: 'timeIn', width: 25 },
            { key: 'deviceNameTimeIn', width: 25 },
            { key: 'timeOut', width: 25 },
            { key: 'deviceNameTimeOut', width: 25 },
            { key: 'employeePersonalInformationEmployeeInformationShiftScheduleShiftName', width: 25 },
        ];
    
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        let _data = mergedLogsData;

        if(type === "Biometrics"){
            _data = biometricsData;
        } else if(type === "Mobile"){
            _data = mobileDTRData;
        }
    
        _data.forEach(item => {
            worksheet.addRow([
                item.employeePersonalInformationEmployeeId ?? "",
                item.employeePersonalInformationFullName ?? "",
                item.date ? formatDate(item.date) : "",
                item.timeIn ? formatTime(item.timeIn) : "",
                item.deviceNameTimeIn ? item.deviceNameTimeIn : "",
                item.timeOut ? formatTime(item.timeOut) : "",
                item.deviceNameTimeOut ? item.deviceNameTimeOut : "",
                item.employeePersonalInformationEmployeeInformationShiftScheduleShiftName ? item.employeePersonalInformationEmployeeInformationShiftScheduleShiftName : "",
            ]);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        let name = 'Merged_Logs.xlsx'

        if(type === "Biometrics"){
            name = 'Biometric_Logs.xlsx'
        } else if(type === "Mobile"){
            name = 'Mobile_Logs.xlsx'
        }

        saveAs(blob, name);
    
        setLoadingRequest(false)
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="TransactionInfo">
                        <div className="transaction-header">
                        <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Transactions >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"DTR (Admin's View)"}</span>
                        </div>
                            <h3>DTR (Admin's View)</h3>
                        </div>
                        <div className="transaction-body">
                            <div style={{padding:"10px"}}>
                                <div className='filters-payroll'>
                                    <div className="payroll-item-holder info-item-holder row" style={{justifyContent:"normal", padding: "0 10px 20px 10px"}}>
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Date From</div>
                                            <div className="info-item-input">
                                                <DateInput date={dateFrom} setDate={setDateFrom}/>
                                            </div>
                                        </div>
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Date To</div>
                                            <div className="info-item-input">
                                                <DateInput date={dateTo} setDate={setDateTo}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="payroll-item-holder info-item-holder row" style={{justifyContent:"normal", padding: "0 10px 20px 10px"}}>
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Employee</div>
                                            <div className="info-item-input employee-select row">
                                                <input
                                                    readOnly
                                                    className='employeeInput-select'
                                                    placeholder="Employee"
                                                    value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                                />
                                                <button className="select row"
                                                        onClick={()=>setShowEmployeeForm(true)}
                                                ><SearchIcon/></button>
                                            </div>
                                        </div>
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input" style={{flexDirection:"row", justifyContent:"normal"}}>
                                                <ClassificationIdSelectWithAll1 classificationId={classificationId} setClassificationId={setClassificationId}/>
                                            </div>
                                        </div>
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Location</div>
                                            <div className="info-item-input">
                                                <LocationIdSelect locationId={locationId} setLocationId={setLocationId}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="rightSide-btn" style={{marginRight:"5px"}}>{CreateButton("", "generate row", (e)=>handleGenerate(e), "GENERATE", RestartAltIcon)}</div>
                                </div>
                            </div>

                            <div className='loan-tab'>
                                <Tabs selectedIndex={selectedTab} onSelect={index => handleSelectChange(index)}>
                                    <TabList>
                                        <Tab><b>MERGED LOGS</b></Tab>
                                        <Tab><b>BIOMETRICS</b></Tab>
                                        <Tab><b>MOBILE</b></Tab>
                                    </TabList>
                                    <div className="loan-tabPanel">
                                        <TabPanel>
                                            <div className="mainte-body-top row">
                                                <div className="w-full">
                                                    {CreateSearchBarWithPlaceHolder("", 
                                                                                        "mainte-search row", 
                                                                                        "mainte-search-icon", 
                                                                                        "mainte-search-input", 
                                                                                        (e) => handleFilterMergedLogs(e.target.value), 
                                                                                        "Search by name", 
                                                                                        SearchIcon)}
                                                </div>
                                                <div className="mainte-addBtn row gap-2">
                                                    {CreateButton("", "save row", ()=>{extractMergedLogs("Merged")}, "EXTRACT", FileDownloadIcon)}
                                                </div>
                                            </div>
                                            <div className="transaction-table container">
                                                <CreateTableForMerged
                                                    dataList={mergedLogsData}
                                                    dataHeader={uploadTimeEntriesHeader_merged}
                                                    dataAccessor={uploadTimeEntriesaccessor_merged}
                                                    currentPage={currentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    openOT={openOT}
                                                    openDTRCorrection={openDTRCorrection}
                                                    openLeave={openLeave}
                                                    openChangeSchedule={openChangeSchedule}
                                                    openOffset={openOffset}
                                                    openOfficialBusiness={openOfficialBusiness}
                                                    openOtherLogs={openOtherLogs}
                                                />
                                            </div>
                                        </TabPanel>
                                        <TabPanel>
                                            <div className="mainte-body-top row">
                                                <div className="w-full">
                                                    {CreateSearchBarWithPlaceHolder("", 
                                                                                    "mainte-search row", 
                                                                                    "mainte-search-icon", 
                                                                                    "mainte-search-input", 
                                                                                    (e) => handleFilterBiometrics(e.target.value), 
                                                                                    "Search by name", 
                                                                                    SearchIcon)}
                                                </div>
                                                <div className="mainte-addBtn row gap-2">
                                                    {CreateButton("", "save row", ()=>{extractMergedLogs("Biometrics")}, "EXTRACT", FileDownloadIcon)}
                                                </div>
                                            </div>
                                            <div className="transaction-table container">
                                                <CreateTable
                                                    dataList={biometricsData}
                                                    dataHeader={uploadTimeEntriesHeader}
                                                    dataAccessor={uploadTimeEntriesaccessor}
                                                    currentPage={currentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            </div>
                                        </TabPanel>
                                        <TabPanel>
                                            <div className="mainte-body-top row">
                                                <div className="w-full">
                                                    {CreateSearchBarWithPlaceHolder("", 
                                                                                    "mainte-search row", 
                                                                                    "mainte-search-icon", 
                                                                                    "mainte-search-input", 
                                                                                    (e) => handleFilterMobile(e.target.value), 
                                                                                    "Search by name", 
                                                                                    SearchIcon)}
                                                </div>
                                                <div className="mainte-addBtn row gap-2">
                                                    {CreateButton("", "save row", ()=>{extractMergedLogs("Mobile")}, "EXTRACT", FileDownloadIcon)}
                                                </div>
                                            </div>
                                            <div className="transaction-table container">
                                                <CreateTable
                                                    dataList={mobileDTRData}
                                                    dataHeader={uploadTimeEntriesHeader}
                                                    dataAccessor={uploadTimeEntriesaccessor}
                                                    currentPage={currentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            </div>
                                        </TabPanel>
                                    </div>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ViewHistoryDTRCorrectionForm  isOpen={showDTRCorrection} 
                    onClose={closeDTRCorrection}
                    requests={requests}
            >
            </ViewHistoryDTRCorrectionForm>
            <ViewHistoryOTForm  isOpen={showOT} 
                    onClose={closeOT}
                    requests={requests}
            >
            </ViewHistoryOTForm>
            <ViewHistoryLeaveForm  isOpen={showLeave} 
                    onClose={closeLeave}
                    requests={requests}
            >
            </ViewHistoryLeaveForm>
            <ViewHistoryChangeScheduleForm  isOpen={showChangeSchedule} 
                    onClose={closeChangeSchedule}
                    requests={requests}
            >
            </ViewHistoryChangeScheduleForm>
            <ViewHistoryOffsetForm
                isOpen={showOffset}
                onClose={closeOffset}
                requests={requests}
            ></ViewHistoryOffsetForm>
            <ViewHistoryOfficialBusinessForm
                isOpen={showOfficialBusiness}
                onClose={closeOfficialBusiness}
                requests={requests}
            ></ViewHistoryOfficialBusinessForm>
            <ViewHistoryOtherLogsForm  isOpen={showOtherLogs} 
                    onClose={closeOtherLogs}
                    requests={requests}
            >
            </ViewHistoryOtherLogsForm>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
                    user={user}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function ViewHistoryDTRCorrectionForm({isOpen, 
    onClose,
    requests
}){

    var header = [
        "Reference No.",
        "Date",
        "Time Type",
        "Time Rendered",
        "Reason",
        "Reason For Rejection",
        // "Date Requested",
        // "Uploaded Image",
        "Itinerary",
        "Status",
    ]
    var accessor = [
        "referenceNumber",
        "date",
        "timeType",
        "timeRendered",
        "reason",
        "reasonForRejection",
        // "dateRequested",
        // "content",
        "changeLogItineraries",
        "status",
    ]
    
    const [showItineraryData, setShowItineraryData] = useState(false);
    const [selectedItinerary, setSelectedItinerary] = useState([]);

    const handleClose = () => {
        onClose();
    };
    
    const openItinerary = (data) =>{
        setSelectedItinerary(data.changeLogItineraries);
        setShowItineraryData(true);
    }
    const closeItinerary = () =>{
        setSelectedItinerary([]);
        setShowItineraryData(false);
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>DTR Adjustment Filed History</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTableForRequests
                                dataList={requests}
                                dataHeader={header}
                                dataAccessor={accessor}
                                openItinerary={openItinerary}
                            />
                            {requests !== null ? (
                                <div></div>
                            )
                            :
                            (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
            <ViewItineraryForm  isOpen={showItineraryData} 
                    onClose={closeItinerary}
                    data={selectedItinerary}
            >
            </ViewItineraryForm>
        </>
    );
}
function ViewHistoryOfficialBusinessForm({isOpen, 
    onClose,
    requests
}){
    var header = [
        "Reference No.",
        "Date",
        "Time Type",
        "Time Rendered",
        "Reason",
        "Reason For Rejection",
        // "Date Requested",
        // "Uploaded Image",
        "Itinerary",
        "Status",
    ]
    var accessor = [
        "referenceNumber",
        "date",
        "timeType",
        "timeRendered",
        "reason",
        "reasonForRejection",
        // "dateRequested",
        // "content",
        "officialBusinessItineraries",
        "status",
    ]
    
    const [showItineraryData, setShowItineraryData] = useState(false);
    const [selectedItinerary, setSelectedItinerary] = useState([]);

    const handleClose = () => {
        onClose();
    };
    
    const openItinerary = (data) =>{
        setSelectedItinerary(data.officialBusinessItineraries);
        setShowItineraryData(true);
    }
    const closeItinerary = () =>{
        setSelectedItinerary([]);
        setShowItineraryData(false);
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Official Business Filed History</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTableForRequests
                                dataList={requests}
                                dataHeader={header}
                                dataAccessor={accessor}
                                openItinerary={openItinerary}
                            />
                            {requests !== null ? (
                                <div></div>
                            )
                            :
                            (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
            <ViewItineraryForm  isOpen={showItineraryData} 
                    onClose={closeItinerary}
                    data={selectedItinerary}
            >
            </ViewItineraryForm>
        </>
    );
}
function ViewHistoryOTForm({isOpen, 
    onClose,
    requests
}){
    var header = [
        "Reference No.",
        "Date",
        "Overtime Type",
        "Hours",
        "Reason",
        "Reason For Rejection",
        // "Date Requested",
        // "Uploaded Image",
        "Status",
    ]
    var accessor = [
        "referenceNumber",
        "date",
        "overtimeType",
        "hours",
        "reason",
        "reasonForRejection",
        // "dateRequested",
        // "content",
        "status",
    ]
    

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>OT Filed History</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTableForRequests
                                dataList={requests}
                                dataHeader={header}
                                dataAccessor={accessor}
                            />
                            {requests !== null ? (
                                <div></div>
                            )
                            :
                            (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewHistoryLeaveForm({isOpen, 
    onClose,
    requests
}){
    var header = [
        "Reference No.",
        "Leave Type",
        "Date From",
        "Date To",
        "Reason",
        "Reason For Rejection",
        // "Date Requested",
        // "Uploaded Image",
        "Status",
    ]
    var accessor = [
        "referenceNumber",
        "leaveTypeDescription",
        "dateFrom",
        "dateTo",
        "reason",
        "reasonForRejection",
        // "dateRequested",
        // "content",
        "status",
    ]
    

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Leave Filed History</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTableForRequests
                                dataList={requests}
                                dataHeader={header}
                                dataAccessor={accessor}
                            />
                            {requests !== null ? (
                                <div></div>
                            )
                            :
                            (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewHistoryChangeScheduleForm({isOpen, 
    onClose,
    requests
}){
    var header = [
        "Reference No.",
        "Date From",
        "Date To",
        "Shift Schedule From",
        "Shift Schedule To",
        "Reason",
        "Reason For Rejection",
        // "Date Requested",
        // "Uploaded Image",
        "Status",
    ]
    var accessor = [
        "referenceNumber",
        "dateFrom",
        "dateTo",
        "shiftScheduleFromShiftName",
        "shiftScheduleToShiftName",
        "reason",
        "reasonForRejection",
        // "dateRequested",
        // "content",
        "status",
    ]
    

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Change Schedule History</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTableForRequests
                                dataList={requests}
                                dataHeader={header}
                                dataAccessor={accessor}
                            />
                            {requests !== null ? (
                                <div></div>
                            )
                            :
                            (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewHistoryOtherLogsForm({isOpen, 
    onClose,
    requests
}){
    var header = [
        "Date",
        "Time",
        "Time Type",
    ]
    var accessor = [
        "date",
        "time",
        "timeType",
    ]
    

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Other Logs</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTableForRequests
                                dataList={requests}
                                dataHeader={header}
                                dataAccessor={accessor}
                            />
                            {requests !== null ? (
                                <div></div>
                            )
                            :
                            (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewHistoryOffsetForm({ isOpen, onClose, requests }) {
    var header = ["Reference No.", "Type", "References", "Date", "Hours", "Date From", "Date To", "Days", "Date (Holiday)", "Days (Holiday)"];
    var accessor = ["referenceNumber", "type", "references", "date", "totalHours", "dateFrom", "dateTo", "totalDays", "holidayDate", "holidayDays"];

    const handleClose = () => {
        onClose();
    };

    const [showReferencesOTData, setShowReferencesOTData] = useState(false);
    const [showReferencesLeaveData, setShowReferencesLeaveData] = useState(false);
    const [selectedReferences, setSelectedReferences] = useState([]);
    
    const openReferences = (data) =>{
        setSelectedReferences(data.references);

        if(data.type === "Overtime"){
            setShowReferencesOTData(true);
        } else if(data.type === "Leave"){
            setShowReferencesLeaveData(true);
        } 
    }
    const closeReferences = () =>{
        setSelectedReferences([]);

        setShowReferencesOTData(false);
        setShowReferencesLeaveData(false);
    }


    return (
        <>
        <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
            {isOpen && (
            <div className="modal">
                <div className="popUp-header row">
                <div className="popUp-title">
                    <h3 style={{ color: "#668fca" }}>Offset</h3>
                </div>
                <div className="popUp-close">
                    <CloseIcon onClick={() => handleClose()} />
                </div>
                </div>
                <div className="popUp-body loan-history-table user-template-body">
                <div
                    className="users-table container"
                    style={{ overflow: "unset" }}
                >
                    <CreateTableForRequests
                    dataList={requests}
                    dataHeader={header}
                    dataAccessor={accessor}
                    openReferences={openReferences}
                    />
                    {requests !== null ? (
                    <div></div>
                    ) : (
                    <div> {/*<p>No records to display</p>*/}</div>
                    )}
                </div>
                </div>
                <div
                className="buttons row"
                style={{
                    justifyContent: "center",
                    padding: "40px 40px 20px 40px",
                }}
                ></div>
            </div>
            )}
        </div>

        <ViewOffsetOvertimeForm isOpen={showReferencesOTData}
            onClose={closeReferences}
            references={selectedReferences}
            setReferences={setSelectedReferences}
        />

        <ViewOffsetLeaveForm isOpen={showReferencesLeaveData}
            onClose={closeReferences}
            references={selectedReferences}
            setReferences={setSelectedReferences}
        />
        </>
    );
}
function ViewItineraryForm({isOpen, 
    onClose,
    data
}){
    var header = [
        "Time In",
        "Time Out",
        "Location",
    ]
    var accessor = [
        "timeIn",
        "timeOut",
        "location",
    ]

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Itinerary</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTableForRequests
                                dataList={data ? data : []}
                                dataHeader={header}
                                dataAccessor={accessor}
                            />
                            {data && data?.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}> {/*<p>No records to display</p>*/}</div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewOffsetOvertimeForm({isOpen, 
    onClose,
    references,
    setReferences
}){
    var header = [
        "Reference Date",
        "Hours",
    ]
    var accessor = [
        "referenceDate",
        "hours",
    ]

    const [currentPage, setCurrentPage] = useState(1);

    const handleClose = () => {
        onClose();
        setCurrentPage(1)
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>References</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="transaction-table container" style={{overflow:"unset", border: "1px solid #c8c3c3"}}>
                            <CreateTableForRequests
                                dataList={references}
                                dataHeader={header}
                                dataAccessor={accessor}
                                
                                currentPage={currentPage} 
                                setCurrentPage={setCurrentPage}
                            />
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewOffsetLeaveForm({isOpen, 
    onClose,
    references,
    setReferences
}){
    var header = [
        "LV Reference No.",
        "Date From",
        "Date To",
        "Days",
    ]
    var accessor = [
        "offsetLeave.leaveData.id",
        "offsetLeave.leaveData.dateFrom",
        "offsetLeave.leaveData.dateTo",
        "offsetLeave.leaveData.days",
    ]

    const [currentPage, setCurrentPage] = useState(1);

    const handleClose = () => {
        onClose();
        setCurrentPage(1)
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>References</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="transaction-table container" style={{overflow:"unset", border: "1px solid #c8c3c3"}}>
                            <CreateTableForRequests
                                dataList={references}
                                dataHeader={header}
                                dataAccessor={accessor}
                                
                                currentPage={currentPage} 
                                setCurrentPage={setCurrentPage}
                            />
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], editHandleClick, deleteHandleClick, currentPage, setCurrentPage }) {
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows?.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    /* const handleRowClick = (rowData) => {
        setSelected(rowData); // Pass the clicked row data to the setSelectedEmployee function
        setActiveRowId(rowData.id);
    }; */

    return (
        <div>
            <div className='scrollable-table'>
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th
                                        {...column.getHeaderProps()}
                                        onClick={() => headerClick(column)}
                                        className="sortable-header"
                                    >
                                        {`${column.render("Header")} ${
                                            sortHeaderValue.id === column.id
                                                ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                                : ""
                                        }`}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {dataList?.length <= 0 &&
                            <tr>
                                <td colSpan={columns?.length} style={{ textAlign: "center" }}>
                                    No data to display
                                </td>
                            </tr>
                        }
                        {currentItems.map((row) => {
                            prepareRow(row)
                            return (
                                <tr key={row.original.id}
                                {...row.getRowProps()} // Attach onClick event handler to the row
                                id={row.original.reasonForTampering ? "tampered" : ""}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfo header={cell.render("Cell").props.column.Header} 
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                        />
                                    ))}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {rows?.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo({header, _cell, editHandleClick, deleteHandleClick}) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if(header === "Status"){
        if(data.isActive){  
            return(
                <td>
                    Active
                </td>
            )
        }
        else{
            return(
                <td>
                    InActive
                </td>
            )
        }
    }

    if(header === "Approved?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isApproved}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    || header === "Time In Break"
    || header === "Time Out Break"
    ){
        let time = _cell.render("Cell").props.value;

        if(!time) {
            return (
                <td>
                </td>
            );
        }

        time = ConvertForTimeLocal(time, header);

        let timeParts;
        const timeSplit = time.split('T');
        if (timeSplit?.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(':');
        } else {
            timeParts = [];
        }
        let hours = parseInt(timeParts[0], 10);
        const minutes = timeParts[1];

        // Convert 24-hour format to 12-hour format and determine AM or PM
        const amPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

        const formattedTime = `${hours}:${minutes} ${amPm}`;

        return (
            <td>
                {formattedTime}
            </td>
        );
    }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    ){
        let date = new Date(_cell.render("Cell").props.value);

        if(!date) {
            return (
                <td>
                </td>
            );
        }

        date = ConvertForDateLocal(data.date, header);


        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
export function CreateTableForMerged({ dataList = [], dataHeader = [], dataAccessor = [], editHandleClick, deleteHandleClick, currentPage, setCurrentPage, openDTRCorrection, openOT, openLeave, openChangeSchedule, openOffset, openOfficialBusiness, openOtherLogs }) {
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows?.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    /* const handleRowClick = (rowData) => {
        setSelected(rowData); // Pass the clicked row data to the setSelectedEmployee function
        setActiveRowId(rowData.id);
    }; */

    return (
        <div>
            <div className='scrollable-table'>
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th
                                        {...column.getHeaderProps()}
                                        onClick={() => headerClick(column)}
                                        className="sortable-header"
                                    >
                                        {`${column.render("Header")} ${
                                            sortHeaderValue.id === column.id
                                                ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                                : ""
                                        }`}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {dataList?.length <= 0 &&
                            <tr>
                                <td colSpan={columns?.length} style={{ textAlign: "center" }}>
                                    No data to display
                                </td>
                            </tr>
                        }
                        {currentItems.map((row) => {
                            prepareRow(row)
                            return (
                                <tr key={row.original.id}
                                {...row.getRowProps()} // Attach onClick event handler to the row
                                id={row.original.reasonForTampering ? "tampered" : ""}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfoForMerged header={cell.render("Cell").props.column.Header} 
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                            openOT={openOT}
                                            openDTRCorrection={openDTRCorrection}
                                            openLeave={openLeave}
                                            openChangeSchedule={openChangeSchedule}
                                            openOffset={openOffset}
                                            openOfficialBusiness={openOfficialBusiness}
                                            openOtherLogs={openOtherLogs}
                                        />
                                    ))}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {rows?.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoForMerged({header, _cell, editHandleClick, deleteHandleClick, openDTRCorrection, openOT, openLeave, openChangeSchedule, openOffset, openOfficialBusiness, openOtherLogs}) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if (header === "OT") {
        return(
            <td>
                { data.otRequest?.length > 0 &&
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        <Tooltip text="View">
                            <div style={{padding:"0 5px"}} onClick={()=>openOT(data)}><RemoveRedEyeIcon/></div>
                        </Tooltip>
                    </div>
                }
            </td>
        )
    }
    if (header === "DTR Adjustment") {
        return(
            <td>
                { data.changeLogRequest?.length > 0 &&
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        <Tooltip text="View">
                            <div style={{padding:"0 5px"}} onClick={()=>openDTRCorrection(data)}><RemoveRedEyeIcon/></div>
                        </Tooltip>
                    </div>
                }
            </td>
        )
    }
    if (header === "Leave") {
        return(
            <td>
                { data.leaveRequest?.length > 0 &&
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        <Tooltip text="View">
                            <div style={{padding:"0 5px"}} onClick={()=>openLeave(data)}><RemoveRedEyeIcon/></div>
                        </Tooltip>
                    </div>
                }
            </td>
        )
    }
    if (header === "Change Schedule") {
        return(
            <td>
                { data.changeScheduleRequest?.length > 0 &&
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        <Tooltip text="View">
                            <div style={{padding:"0 5px"}} onClick={()=>openChangeSchedule(data)}><RemoveRedEyeIcon/></div>
                        </Tooltip>
                    </div>
                }
            </td>
        )
    }
    if (header === "Offset") {
        return (
        <td>
            {data?.offsetRequest?.length > 0 && (
            <div
                className="row"
                style={{ alignItems: "center", justifyContent: "center" }}
            >
                <Tooltip text="View">
                <div style={{ padding: "0 5px" }} onClick={() => openOffset(data)}>
                    <RemoveRedEyeIcon />
                </div>
                </Tooltip>
            </div>
            )}
        </td>
        );
    }
    if (header === "Official Business") {
        return (
        <td>
            {data?.officialBusiness?.length > 0 && (
            <div
                className="row"
                style={{ alignItems: "center", justifyContent: "center" }}
            >
                <Tooltip text="View">
                <div style={{ padding: "0 5px" }} onClick={() => openOfficialBusiness(data)}>
                    <RemoveRedEyeIcon />
                </div>
                </Tooltip>
            </div>
            )}
        </td>
        );
    }
    if (header === "Other Logs") {
        return(
            <td>
                { data.otherLogs?.length > 0 &&
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        <Tooltip text="View">
                            <div style={{padding:"0 5px"}} onClick={()=>openOtherLogs(data)}><RemoveRedEyeIcon/></div>
                        </Tooltip>
                    </div>
                }
            </td>
        )
    }

    if(header === "Status"){
        if(data.isActive){  
            return(
                <td>
                    Active
                </td>
            )
        }
        else{
            return(
                <td>
                    InActive
                </td>
            )
        }
    }

    if(header === "Approved?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isApproved}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    || header === "Time In Break"
    || header === "Time Out Break"
    ){
        let time = _cell.render("Cell").props.value;

        if(!time) {
            return (
                <td>
                </td>
            );
        }

        time = ConvertForTimeLocal(time, header);

        let timeParts;
        const timeSplit = time.split('T');
        if (timeSplit?.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(':');
        } else {
            timeParts = [];
        }
        let hours = parseInt(timeParts[0], 10);
        const minutes = timeParts[1];

        // Convert 24-hour format to 12-hour format and determine AM or PM
        const amPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

        const formattedTime = `${hours}:${minutes} ${amPm}`;

        return (
            <td>
                {formattedTime}
            </td>
        );
    }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Reference Date"
    || header === "Request Date"
    ){
        let date = new Date(_cell.render("Cell").props.value);

        if(!date) {
            return (
                <td>
                </td>
            );
        }

        date = ConvertForDateLocal(data.date, header);


        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
export function CreateTableForRequests({ dataList = [], 
    setDataList,
    dataHeader = [], 
    dataAccessor = [], 
    editHandleClick, 
    deleteHandleClick, 
    isItinerayAddState,
    setIsItinerayAddState,
    isItinerayUpdateState,
    setIsItinerayUpdateState,
    isItinerayDeleteState,
    setIsItinerayDeleteState,
    itineraryTimeIn,
    setItineraryTimeIn,
    itineraryTimeOut,
    setItineraryTimeOut,
    itineraryLocation,
    setItineraryLocation,
    locationData,
    openItinerary,
    openReferences
}) {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [idCounter, setIdCounter] = useState(0);
    const [recoveredData, setRecoveredData] = useState([]);

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ columns, data: dataList });

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows?.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const newData = {
        id: idCounter + 1,
        itineraryTimeIn: itineraryTimeIn,
        itineraryTimeOut: itineraryTimeOut,
        itineraryLocation: itineraryLocation,
    }

    const saveAdd = () =>{
        setIdCounter(idCounter + 1);
        setIsItinerayAddState(false);
        setIsItinerayUpdateState(false);
        setDataList(prevDataList => [
            ...prevDataList, 
            newData
        ]);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");
    }

    const cancelAdd = () =>{
        setIsItinerayAddState(false);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");
    }

    const updateClick = (data) =>{
        setRecoveredData(data);
        setItineraryTimeIn(data.itineraryTimeIn);
        setItineraryTimeOut(data.itineraryTimeOut);
        setItineraryLocation(data.itineraryLocation);
        const foundData = dataList.find(_data => _data.id === data.id);

        setDataList(prevDataList => 
            prevDataList.filter(_data => _data.id !== foundData.id)
        );

        setIsItinerayUpdateState(true);
    }
    const cancelUpdate = () =>{
        setIdCounter(idCounter + 1);

        const oldData = {
            id: recoveredData.id,
            itineraryTimeIn: recoveredData.itineraryTimeIn,
            itineraryTimeOut: recoveredData.itineraryTimeOut,
            itineraryLocation: recoveredData.itineraryLocation,
        }

        setDataList(prevDataList => [
            ...prevDataList, 
            oldData
        ]);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");

        setIsItinerayUpdateState(false);
    }
    const deleteClick = (data) =>{
        const foundData = dataList.find(_data => _data.id === data.id);

        setDataList(prevDataList => 
            prevDataList.filter(_data => _data.id !== foundData.id)
        );
    }

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    {
                                    column.render("Header")
                                    }
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {isItinerayAddState ?
                        <tr>
                            <td>
                                <TimeInput date={itineraryTimeIn} setDate={setItineraryTimeIn}/>
                            </td>
                            <td>
                                <TimeInput date={itineraryTimeOut} setDate={setItineraryTimeOut}/>
                            </td>
                            <td>
                                <input
                                    placeholder="Enter location"
                                    value={itineraryLocation}
                                    onChange={(e) => setItineraryLocation(e.target.value)}
                                    style={{color: "gray",
                                        height: "30px",
                                        borderRadius: "3px",
                                        border: "1px solid #80808080",
                                        outline: "none",
                                        width: "90%"
                                    }}
                                />
                            </td>
                            <td>
                                <div className="row itinerary-manage"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <Tooltip text="Save">
                                        <div style={{padding:"0 5px"}} onClick={saveAdd}><SaveIcon/></div>
                                    </Tooltip>
                                    <Tooltip text="Cancel">
                                        <div style={{padding:"0 5px"}} onClick={cancelAdd}><DoDisturbIcon/></div>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                        :
                        <></>
                    }
                    {isItinerayUpdateState &&
                        <tr>
                            <td>
                                <TimeInput date={itineraryTimeIn} setDate={setItineraryTimeIn}/>
                            </td>
                            <td>
                                <TimeInput date={itineraryTimeOut} setDate={setItineraryTimeOut}/>
                            </td>
                            <td>
                                <input
                                    placeholder="Enter location"
                                    value={itineraryLocation}
                                    onChange={(e) => setItineraryLocation(e.target.value)}
                                    style={{color: "gray",
                                        height: "30px",
                                        borderRadius: "3px",
                                        border: "1px solid #80808080",
                                        outline: "none",
                                        width: "90%"
                                    }}
                                />
                            </td>
                            <td>
                                <div className="row itinerary-manage"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <Tooltip text="Save">
                                        <div style={{padding:"0 5px"}} onClick={saveAdd}><SaveIcon/></div>
                                    </Tooltip>
                                    <Tooltip text="Cancel">
                                        <div style={{padding:"0 5px"}} onClick={cancelUpdate}><DoDisturbIcon/></div>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfoRequest(cell.render("Cell").props.column.Header, 
                                            cell,
                                            updateClick,
                                            deleteClick,
                                            locationData,
                                            openItinerary,
                                            openReferences
                                        )
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows?.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoRequest(header, _cell, editHandleClick, deleteHandleClick, locationData, openItinerary, openReferences) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if (header === "Itinerary") {
        if(value.length <= 0){
            return(
                <td>
                </td>
            )
        }

        return(
            <td>
                <div className="itineary-control row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>openItinerary(data)}><ListIcon/></div>
                    </Tooltip>
                </div>
            </td>
        )
    }

    if (header === "References") {
        if(value.length <= 0){
            return(
                <td>
                </td>
            )
        }

        return(
            <td>
                <div className="itineary-control row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>openReferences(data)}><ListIcon/></div>
                    </Tooltip>
                </div>
            </td>
        )
    }

    if(header === "Uploaded Image"){
        if(data.content){
            const imageSrc = 'data:image/jpeg;base64,' + data.content;

            return(
                <td>
                    <img className="" src={imageSrc} alt="" style={{width: "250px", height: "auto"}}/>
                </td>
            )
        }
        return(
            <td>
                <img className="" src="" alt=""/>
            </td>
        )
    }

    if( header === "Time In"
    || header === "Time Out"
    || header === "Time Rendered"
    || header === "Time"
    || header === "Time In Break"
    || header === "Time Out Break"
    ){
        const time = _cell.render("Cell").props.value;

        if (!time) {
            return (
                <td>
                    null
                </td>
            );
        }
    
        let formattedTime = '';
    
        // Attempt to parse the time if it’s not already in ISO format
        let date;
        if (time.includes('T')) {
            date = new Date(time);
        } else {
            // If the time is not in ISO format, manually create the date
            const currentDate = new Date(); // Get current date for the date portion
            const [hours, minutes] = time.split(':').map(part => parseInt(part, 10));
    
            if (isNaN(hours) || isNaN(minutes)) {
                return (
                    <td>
                        Invalid time format
                    </td>
                );
            }
    
            date = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), hours, minutes);
        }
    
        if (isNaN(date.getTime())) {
            return (
                <td>
                    Invalid time format
                </td>
            );
        }
    
        // Convert to desired format YYYY-MM-DDTHH:mm
        // const year = date.getFullYear();
        // const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        // const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
    
        // const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    
        // console.log(formattedDateTime); // Logs the converted time for debugging
    
        // Further formatting based on globalTimeFormat
        if (globalTimeFormat === "Standard Time") {
            const amPm = date.getHours() >= 12 ? 'PM' : 'AM';
            const standardHours = (date.getHours() % 12) || 12; // Convert 0 to 12 for 12-hour format
    
            formattedTime = `${standardHours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time") {
            formattedTime = `${hours}:${minutes}`;
        }
    
        return (
            <td>
                {formattedTime}
            </td>
        );
    }

    if(header === "Hours" 
        || header === "Days"
        || header === "Days (Holiday)"
    ){
        const value = _cell.render("Cell").props.value;

        if(data.requestTypeDescription === "Offset"){
            if(data.offsetType === "Leave" && header === "Hours"){
                return(
                    <td>
                        {`Not applicable to Type: ${data.offsetType}`}
                    </td>
                )
            }

            if(data.offsetType === "Leave" && header === "Days (Holiday)"){
                return(
                    <td>
                        {`Not applicable to Type: ${data.offsetType}`}
                    </td>
                )
            }

            if(data.offsetType === "Overtime" && header === "Days"){
                return(
                    <td>
                        {`Not applicable to Type: ${data.offsetType}`}
                    </td>
                )
            }

            if(data.offsetType === "Overtime" && header === "Days (Holiday)"){
                return(
                    <td>
                        {`Not applicable to Type: ${data.offsetType}`}
                    </td>
                )
            }

            if(data.offsetType === "Holiday" && header === "Days"){
                return(
                    <td>
                        {`Not applicable to Type: ${data.offsetType}`}
                    </td>
                )
            }

            if(data.offsetType === "Holiday" && header === "Hours"){
                return(
                    <td>
                        {`Not applicable to Type: ${data.offsetType}`}
                    </td>
                )
            }
        }

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    if (header === "Status") {
        let convertedValue = value;

        if(convertedValue === "Sent"){
            convertedValue = "Pending";
        }
        return(
            <td className={convertedValue}>
                {convertedValue}
            </td>
        )
    }

    if(header === "Reference No."){
        const formattedNumber = value.toString().padStart(6, '0');

        if(data.requestTypeId === 1){
            return (
                <td>
                    LV-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 2){
            return (
                <td>
                    CS-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 3){
            return (
                <td>
                    OT-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 4){
            return (
                <td>
                    CH-{formattedNumber}
                </td>
            );
        }  else if(data.requestTypeId === 5){
            return (
                <td>
                    OS-{formattedNumber}
                </td>
            );
        }  else if(data.requestTypeId === 6){
            return (
                <td>
                    OB-{formattedNumber}
                </td>
            );
        } 
    }

    if(header === "LV Reference No."){
        const formattedNumber = value.toString().padStart(6, '0');

        return (
            <td>
                LV-{formattedNumber}
            </td>
        );
    }

    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Reference Date"
    || header === "Date Requested"
    || header === "Date (Holiday)"
    ){
        if(data.requestTypeDescription === "Offset"){
            if(!value){
                return(
                    <td>
                        {`Not applicable to Type: ${data.type}`}
                    </td>
                )
            }
        }

        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function TimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="time"
            id={"time"}
            name="datetime"
            value={date.slice(0, 16)} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function DateInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={date}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
const ConvertForDateLocal = (dateString) => {
    // console.log("dateString", dateString);

    if (!dateString) {
        console.log("Invalid or empty date string");
        return null;
    }

    const dateTimeParts = dateString.split('T');
    if (dateTimeParts?.length !== 2) {
        console.log("Invalid date string format");
        return null;
    }

    const datePart = dateTimeParts[0]; // YYYY-MM-DD
    const timePart = dateTimeParts[1]; // HH:MM:SS

    const [year, month, day] = datePart.split('-');
    const [hours, minutes, seconds] = timePart.split(':');

    const date = new Date(
        parseInt(year, 10), 
        parseInt(month, 10) - 1, // JS months are 0-indexed
        parseInt(day, 10), 
        parseInt(hours, 10), 
        parseInt(minutes, 10), 
        parseInt(seconds, 10)
    );

    return date;
};
const ConvertForTimeLocal = (dateString, name) => {
    // console.log("timeString", dateString);

    if (!dateString) {
        console.log(`${name} is empty or invalid data`);
        return "";
    }

    // Split the date and time parts
    const [datePart, timePart] = dateString.split('T');

    if (!timePart) {
        console.log(`${name} does not have a valid time part`);
        return "";
    }

    // Parse the date part
    const [year, month, day] = datePart.split('-');
    
    // Parse the time part
    const [hour, minute, second] = timePart.split(':');
    let hour24 = parseInt(hour, 10);

    // Construct the Date object
    const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), hour24, parseInt(minute, 10), parseInt(second, 10));

    // Format the date string in the desired format
    const formattedDateString = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}T${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

    return formattedDateString;
};
function ClassificationIdSelectWithAll1({classificationId, setClassificationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose classification</option>
                {data?.length > 0 && <option value="0">All</option>}
                {data.map((classificationId) => ( 
                    SetClassificationId(classificationId)
                ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="0" >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
function EmployeeSelectForm({isOpen, 
    onClose,
    user,
    setEmployeeId,
    setEmployee}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Employee/basic-info/all/active`;

        try {
            setLoading(true);
            const response = await axios.post(apiUrl , user, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [user])
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex, fetchData]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees?.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};

export default DTRAdminView
